<template>
  <v-dialog v-model="ui.show" persistent>
    <v-card>
      <!-- HEADER -->
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">Modifica Formato</v-toolbar-title>
        <v-spacer />
        <v-btn small @click="clickChiudi">
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- BODY -->
      <v-container>
        <v-row align="center">
          <v-col cols="3">
            <!-- TABS DI SINISTRA -->
            <v-tabs vertical v-model="ui.tabs">
              <v-tab v-for="(item, i) in regole" :key="i">
                <v-row align="center">
                  <v-col cols="4" justify="start">
                    <v-btn icon small @click.stop="remove_rule(i)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="4" justify="center">Regola {{ i + 1 }}</v-col>
                </v-row>
              </v-tab>
              <v-btn text color="success" @click="add_rule">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </v-tabs>
          </v-col>
          <v-col cols="9">
            <!-- CONTENUTO -->
            <v-tabs-items v-model="ui.tabs">
              <v-tab-item v-for="(item, i) in regole" :key="i">
                <v-container>
                  <v-card-title class="px-0">Condizioni</v-card-title>
                  <!-- SWITCH -->
                  <v-row>
                    <v-col cols="4" justify="center">
                      <v-switch
                        :label="item.static ? 'Statica' : 'Condizionale'"
                        v-model="item.static"
                      />
                    </v-col>
                    <v-col cols="4" justify="center" v-if="item.static != true">
                      <v-switch
                        :label="item.range ? 'Range' : 'Confronto'"
                        v-model="item.range"
                      />
                    </v-col>
                    <!-- <v-col cols="4" justify="center" v-if="item.static != true">
                      <v-switch
                        :label="item.query ? 'Usa Query' : 'Usa valore fisso'"
                        v-model="item.query"
                      />
                    </v-col> -->
                  </v-row>
                  <!-- INPUT RANGE -->
                  <v-row
                    align="center"
                    justify="start"
                    v-if="item.range == true && item.static != true"
                  >
                    <v-col cols="3">
                      <p style="text-align: left; font-size: 14px">
                        Compreso tra
                      </p>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model="item.start_ref"
                        v-if="item.query != true"
                      />
                      <v-select
                        v-model="item.start_ref"
                        v-if="item.query == true"
                        :items="value.condizioni"
                        item-value="cod"
                        item-text="cod"
                      />
                    </v-col>
                    <v-col cols="3">
                      <p style="font-size: 14px">e</p>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model="item.end_ref"
                        v-if="item.query != true"
                      />
                      <v-select
                        v-model="item.end_ref"
                        v-if="item.query == true"
                        :items="value.condizioni"
                        item-value="cod"
                        item-text="cod"
                      />
                    </v-col>
                  </v-row>
                  <!-- INPUT VALORE -->
                  <v-row
                    align="center"
                    justify="start"
                    v-if="item.range != true && item.static != true"
                  >
                    <v-col cols="6">
                      <v-select
                        v-model="item.operation"
                        :items="get_compare(value)"
                        item-text="text"
                        item-value="value"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="item.start_ref"
                        v-if="item.query != true"
                      />
                      <v-select
                        v-model="item.start_ref"
                        v-if="item.query == true"
                        :items="value.condizioni"
                        item-value="cod"
                        item-text="cod"
                      />
                    </v-col>
                  </v-row>
                  <!-- IMPOSTAZIONI STRINGA -->
                  <div>
                    <v-divider />
                    <v-card-title class="px-0">Opzioni Stringa</v-card-title>
                    <v-row justify="center">
                      <v-checkbox
                        v-model="item.string.case_sensitive"
                        label="Case sensitive"
                      />
                    </v-row>
                  </div>

                  <!-- FORMATO CELLA (SOLO TABELLE) -->
                  <div>
                    <v-divider />
                    <v-card-title class="px-0">Formato Cella</v-card-title>
                    <v-row align="center">
                      <v-col cols="6" align="left">
                        <span :style="get_style(item)">Abc</span>
                      </v-col>
                      <v-col cols="6">
                        <v-btn-toggle v-model="item.align">
                          <v-btn>
                            <v-icon>mdi-format-align-left</v-icon>
                          </v-btn>
                          <v-btn>
                            <v-icon>mdi-format-align-center</v-icon>
                          </v-btn>
                          <v-btn>
                            <v-icon>mdi-format-align-right</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                      <v-col cols="3">
                        <v-text-field
                          v-model="item.font_size"
                          type="number"
                          min="1"
                          label="Dimensioni Font"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-checkbox v-model="item.bold" label="Grassetto" />
                      </v-col>
                      <v-col cols="3">
                        <v-checkbox v-model="item.italic" label="Corsivo" />
                      </v-col>
                      <v-col cols="3">
                        <v-checkbox
                          v-model="item.underlined"
                          label="Sottolineato"
                        />
                      </v-col>
                    </v-row>
                    <!-- COLORI CELLA -->
                    <v-row justify="center" align="center">
                      <v-col cols="6" justify="center" align="center">
                        <span style="display: block; font-size: 16px"
                          >Sfondo Cella</span
                        >
                        <v-color-picker
                          mode="hexa"
                          hide-mode-switch
                          hide-s
                          v-model="item.color"
                          canvas-height="100"
                        />
                      </v-col>
                      <v-col cols="6" justify="center" align="center">
                        <span style="display: block; font-size: 16px"
                          >Colore Testo</span
                        >
                        <v-color-picker
                          mode="hexa"
                          hide-mode-switch
                          hide-s
                          v-model="item.font_color"
                          canvas-height="100"
                        />
                      </v-col>
                    </v-row>
                    <!-- FORMATTAZIONE VALORE -->
                    <v-divider />
                    <v-card-title class="px-0">Formato Valore</v-card-title>
                    <p class="helper">
                      <strong>{valore}</strong> per il valore della cella
                    </p>
                    <v-text-field label="Formula" v-model="item.formatter" />
                  </div>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
      <!-- TASTO SALVA -->
      <v-card-actions>
        <v-spacer />
        <v-btn text color="success" @click="save">
          <v-icon class="mr-2">mdi-floppy</v-icon>Salva modifiche</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "FormatoQTT",
  props: {
    value: String,
    show: {
      type: Boolean,
      default: false,
    },
    item: Object,
  },
  data() {
    return {
      index: -1,
      compare_num: [
        { text: "Minore di", value: 0 },
        { text: "Minore o uguale a", value: 1 },
        { text: "Uguale a", value: 2 },
        { text: "Maggiore o uguale a", value: 3 },
        { text: "Maggiore di", value: 4 },
        { text: "Diverso da", value: 5 },
      ],
      compare_str: [
        { text: "Uguale a", value: 0 },
        { text: "Diverso da", value: 1 },
      ],
      regole: null,
      template: {
        color: "#ffffff",
        operation: 0,
        query: false,
        range: true,
        compiled_style: "",
        align: 0,
        bold: false,
        font_color: "#000000",
        font_size: 13,
        italic: false,
        underlined: false,
        start_ref: null,
        string: {
          case_sensitive: false,
        },
        end_ref: null,
        static: false,
        formatter: "{valore}",
      },
      ui: {
        show: false,
        tabs: 0,
      },
    };
  },
  mounted() {
    // document.body.addEventListener("graph_editor_formato", this.show_editor);
  },
  beforeDestroy() {
    // document.body.removeEventListener("graph_editor_formato", this.show_editor);
  },
  destroyed() {
    // window.freeComponent(this);
  },
  watch: {
    show: {
      immediate: true,
      handler() {
        if (this.show === true) {
          this.ui.show = this.show;
          this.show_editor();
        }
      },
    },
  },
  methods: {
    add_rule() {
      let new_item = Object.assign({}, this.template);
      this.regole.push(new_item);
    },
    clickChiudi() {
      this.$emit("chiudi_dialg_formato");
      this.ui.show = false;
    },
    remove_rule(index) {
      if (this.regole[index] == undefined) {
        return;
      }
      this.regole.splice(index, 1);
    },
    get_compare() {
      return this.compare_num;
    },
    get_style(item, compile = false) {
      if (item.font_size > 60) {
        item.font_size = 60;
      }
      let align = ["left", "center", "right"];
      align = align[item.align];
      let style =
        `background-color:${item.color};
            text-align:${align};
            font-weight:` +
        (item.bold ? "bold" : "normal") +
        `;
            color:${item.font_color};
            font-size:${item.font_size}px;
            font-style:` +
        (item.italic ? "italic" : "normal") +
        `;
            text-decoration:` +
        (item.underlined ? "underline" : "none") +
        ";";
      if (compile == false) {
        style +=
          "display:block;border:thin solid rgba(0,0,0,.12);max-width:200px";
      }
      return style.replaceAll("\n", "");
    },
    save() {
      for (let i = 0; i < this.regole.length; i++) {
        this.regole[i].compiled_style = this.get_style(this.regole[i], true);
      }
      let encoded = JSON.stringify(this.regole);
      // codifica del campo EXTRA come json codificato in base64 (con supporto per UTF-8)

      this.item.formato = btoa(unescape(encodeURIComponent(encoded)));
      this.ui.show = false;
      this.$emit("chiudi_dialg_formato");
    },
    show_editor() {
      try {
        // il campo EXTRA è un json codificato in base64 (con supporto per UTF-8)
        this.regole = JSON.parse(
          decodeURIComponent(escape(atob(this.item.formato)))
        );
      } catch (error) {
        this.regole = [];
      }
      this.ui.show = true;
    },
  },
};
</script>